import { Button, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"

export const ButtonNewStatus = ({ id, eventType, status, sessionId, sendMessage }) => {
    if (eventType === 0) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    data-status={1}
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
    if (eventType === 1) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                    onClick={() => { sendMessage(id, 2, sessionId) }}
                    color="success">Сдал тест</Button>
            )
        }
        if (status === 2) {
            return (
                <ButtonGroup>
                    <Button
                        className="text-nowrap"
                        size="sm"
                        //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                        onClick={() => { sendMessage(id, 3, sessionId) }}
                        color="success">Отриц.</Button>
                    <Button
                        onClick={() => { sendMessage(id, 4, sessionId) }}
                        className="text-nowrap"
                        size="sm"
                        color="danger">
                        Полож.
                    </Button>
                </ButtonGroup>
            )
        }
        if (status === 3) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
    if (eventType === 2) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                    onClick={() => { sendMessage(id, 2, sessionId) }}
                    color="success">Сдал тест</Button>
            )
        }
    }
    if (eventType === 3) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                    onClick={() => { sendMessage(id, 5, sessionId) }}
                    color="success">Заказ выдан</Button>
            )
        }
        if (status === 5) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    data-status={1}
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
    if (eventType === 4) {
        if (status === 0) {
            return (
                <UncontrolledDropdown
                    className="me-2"
                    direction="down"
                >
                    <DropdownToggle
                        caret
                        color="success"
                        size="sm"
                    >
                        Кабинка
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 1) }}>
                            Кабинка 1
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 2) }}>
                            Кабинка 2
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 3) }}>
                            Кабинка 3
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 4) }}>
                            Кабинка 4
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 5) }}>
                            Кабинка 5
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 6) }}>
                            Кабинка 6
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 7) }}>
                            Кабинка 7
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 8) }}>
                            Кабинка 8
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 9) }}>
                            Кабинка 9
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 10) }}>
                            Кабинка 10
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                // <Button
                //     className="text-nowrap"
                //     size="sm"
                //     data-id={id}
                //     //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                //     onClick={() => { sendMessage(id, 2, sessionId) }}
                //     color="success">Сдал тест</Button>
            )
        }
        if (status === 2) {
            return (
                <ButtonGroup>
                    <Button
                        className="text-nowrap"
                        size="sm"
                        //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                        onClick={() => { sendMessage(id, 3, sessionId) }}
                        color="success">Отриц.</Button>
                    <Button
                        onClick={() => { sendMessage(id, 4, sessionId) }}
                        className="text-nowrap"
                        size="sm"
                        color="danger">
                        Полож.
                    </Button>
                </ButtonGroup>
            )
        }
        if (status === 3) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
    if (eventType === 5) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    data-status={1}
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
    if (eventType === 6) {
        if (status === 0) {
            return (
                <UncontrolledDropdown
                    className="me-2"
                    direction="down"
                >
                    <DropdownToggle
                        caret
                        color="success"
                        size="sm"
                    >
                        Кабинка
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 1) }}>
                            Кабинка 1
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 2) }}>
                            Кабинка 2
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 3) }}>
                            Кабинка 3
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 4) }}>
                            Кабинка 4
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 5) }}>
                            Кабинка 5
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 6) }}>
                            Кабинка 6
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 7) }}>
                            Кабинка 7
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 8) }}>
                            Кабинка 8
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 9) }}>
                            Кабинка 9
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 2, sessionId, 10) }}>
                            Кабинка 10
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                // <Button
                //     className="text-nowrap"
                //     size="sm"
                //     data-id={id}
                //     //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                //     onClick={() => { sendMessage(id, 2, sessionId) }}
                //     color="success">Сдал тест</Button>
            )
        }
        if (status === 2) {
            return (
                <ButtonGroup>
                    <Button
                        className="text-nowrap"
                        size="sm"
                        //1)Id базы объекта, 2)Номер нового статуса, 3)Список  
                        onClick={() => { sendMessage(id, 3, sessionId) }}
                        color="success">Отриц.</Button>
                    <Button
                        onClick={() => { sendMessage(id, 4, sessionId) }}
                        className="text-nowrap"
                        size="sm"
                        color="danger">
                        Полож.
                    </Button>
                </ButtonGroup>
            )
        }
        if (status === 3) {
            return (
                <UncontrolledDropdown
                    className="me-2"
                    direction="down"
                >
                    <DropdownToggle
                        caret
                        color="warning"
                        size="sm"
                    >
                        Стол
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 1) }}>
                            Стол 1
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 2) }}>
                            Стол 2
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 3) }}>
                            Стол 3
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 4) }}>
                            Стол 4
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 5) }}>
                            Стол 5
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 6) }}>
                            Стол 6
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 7) }}>
                            Стол 7
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 8) }}>
                            Стол 8
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 9) }}>
                            Стол 9
                        </DropdownItem>
                        <DropdownItem onClick={() => { sendMessage(id, 1, sessionId, 10) }}>
                            Стол 10
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        }
    }
    if (eventType === 7) {
        if (status === 0) {
            return (
                <Button
                    className="text-nowrap"
                    size="sm"
                    data-id={id}
                    data-status={1}
                    onClick={() => { sendMessage(id, 1, sessionId) }}
                    color="success">На месте</Button>
            )
        }
    }
}